import React from 'react'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import { HeaderBackButton } from '@react-navigation/elements'
import {
  View,
  StyleSheet,
} from 'react-native'

import {
  Text
} from '@sart/components'
import { CompanyIcon } from '@sart/icons'
import { useContent } from '@sart/content'
import {
  adaptive,
  colors,
  backgroundColors,
  theme,
  typography
} from '@sart/styles'

import { stackNavigationProps } from '../nagivationProps'
import Inbox from './Inbox'
import DisplayNotification from './DisplayNotification'
import NotificationConfirmation from './NotificationConfirmation'
import NotificationError from './NotificationError'
import NotificationProvisioning from './NotificationProvisioning'
import { CheckoutNavigationStacks } from '../Checkout'

const Stack = createNativeStackNavigator()

function InboxStackNavigator() {

	const content = useContent()

	return (
		<Stack.Navigator
			initialRouteName="Inbox"
			screenOptions={{
        headerTitleAlign: 'center',
        ...stackNavigationProps.screenOptions
      }}
		>
			<Stack.Screen
				name="Inbox"
				component={Inbox}
				options={{
          title: content.navigation.inbox,
					headerTitleStyle: theme.navigationHeader,
          headerLeft: () => (<View style={{paddingLeft: 15, marginTop:0}}>
            <CompanyIcon color={colors.srGreen} height={50} width={50} />
          </View>
          ),
          headerTopInsetEnabled:true
        }}
			/>
			<Stack.Screen
				name="DisplayNotification"
				component={DisplayNotification}
				options={({ navigation }) => ({
          title: '',
          headerTopInsetEnabled:true,
					headerLeft: () => (
            <HeaderBackButton
              backTitleVisible={true}
              title={content.navigation.inbox}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Inbox')
              }}
              tintColor={colors.srGreen}
            />
          )
        })}
			/>
			<Stack.Screen
				name="NotificationConfirmation"
				component={NotificationConfirmation}
				options={({ navigation }) => ({
          title: '',
          headerTopInsetEnabled:true,
					headerLeft: () => (
            <HeaderBackButton
              backTitleVisible={true}
              title={content.navigation.inbox}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Inbox')
              }}
              tintColor={colors.srGreen}
            />
          )
        })}
			/>
			<Stack.Screen
				name="NotificationError"
				component={NotificationError}
				options={({ navigation }) => ({
          title: '',
          headerTopInsetEnabled:true,
					headerLeft: () => (
            <HeaderBackButton
              backTitleVisible={true}
              title={content.navigation.inbox}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Inbox')
              }}
              tintColor={colors.srGreen}
            />
          )
        })}
			/>
			<Stack.Screen
				name="NotificationProvisioning"
				component={NotificationProvisioning}
				options={{
          title: '',
          headerTopInsetEnabled:true,
					headerLeft: () => (
					<View style={{paddingLeft: 15, marginTop:0}}>
            <CompanyIcon color={colors.srGreen} height={50} width={50} />
          </View>
          ),
        }}
			/>
			<Stack.Screen
        name="Checkout"
        component={CheckoutNavigationStacks}
        options={({ navigation }) => ({
          headerTitleStyle: theme.navigationHeader,
        })}
      />
		</Stack.Navigator>
	)
}

export default InboxStackNavigator